import React from 'react';
import LegalLayout from './LegalLayout';

export default function Privacy() {
  return (
    <LegalLayout title="Политика конфиденциальности" updated="16 сентября 2026 года">
      <p>
        Настоящая Политика обработки персональных данных (далее — «Политика»)
        разработана в соответствии с требованиями Федерального закона от 27.07.2006
        № 152-ФЗ «О персональных данных» (далее — «Закон о персональных данных»),
        Федерального закона от 27.07.2006 № 149-ФЗ «Об информации, информационных
        технологиях и о защите информации», постановления Правительства Российской
        Федерации от 01.11.2012 № 1119, а также иных нормативных правовых актов
        Российской Федерации в области персональных данных.
      </p>
      <p>
        Политика определяет порядок обработки персональных данных, цели, правовые
        основания, способы, условия, сроки хранения и меры по обеспечению
        безопасности персональных данных при предоставлении доступа к сервису
        email-аутрича Mailora, при регистрации и авторизации пользователей,
        использовании функционала (загрузка собственных почтовых ящиков, загрузка
        баз получателей, создание цепочек и авторассылок, настройка
        персонализации, встроенный инбокс, Telegram-уведомления), приеме платежей,
        направлении уведомлений, а также при взаимодействии с пользователями через
        сайт https://mailora.ru или https://app.mailora.ru, приложение и иные каналы связи.
      </p>
      <p>
        Политика опубликована в свободном доступе на официальном сайте Сервиса и
        является обязательной для ознакомления всеми субъектами персональных
        данных, которые регистрируются в Сервисе, используют его функционал,
        оформляют тариф или иным образом взаимодействуют с Оператором.
      </p>
      <p>
        Оператор вправе вносить изменения в настоящую Политику в случае изменения
        процессов обработки, расширения функционала Сервиса, изменения
        законодательства Российской Федерации или требований уполномоченного
        органа. Актуальная версия Политики размещается на сайте Сервиса.
        Продолжение использования Сервиса после опубликования новой редакции
        Политики означает согласие субъекта персональных данных с внесёнными
        изменениями.
      </p>

      <h2>1. Общие положения</h2>
      <p>
        1.1. Настоящая Политика является локальным документом Оператора и
        устанавливает принципы, цели, правовые основания, способы, условия и
        порядок обработки персональных данных, а также меры по обеспечению их
        безопасности при осуществлении деятельности по предоставлению доступа к
        сервису Mailora.
      </p>
      <p>
        1.2. Оператор осуществляет обработку персональных данных в целях
        предоставления пользователям доступа к функционалу Сервиса (регистрация,
        авторизация, подключение почтовых ящиков, загрузка баз получателей,
        создание цепочек и авторассылок, настройка персонализации, встроенный
        инбокс, Telegram-уведомления, аналитика), обеспечения безопасности
        Сервиса, исполнения договора (публичной оферты), направления сервисных и
        маркетинговых уведомлений, а также улучшения качества Сервиса.
      </p>
      <p>
        1.3. Обработка персональных данных осуществляется с соблюдением всех
        принципов и правил, предусмотренных Законом о персональных данных, и
        направлена на обеспечение защиты прав и свобод субъектов персональных
        данных.
      </p>
      <p>
        1.4. Политика применяется ко всем персональным данным, которые Оператор
        получает и обрабатывает в связи с использованием сайта, приложения,
        оформлением тарифа, обращением в поддержку и иными действиями
        пользователя.
      </p>
      <p>
        1.5. Персональные данные граждан Российской Федерации обрабатываются с
        использованием баз данных, расположенных на территории Российской
        Федерации. Серверы и инфраструктура Сервиса размещены в Российской
        Федерации.
      </p>
      <p>
        1.6. Настоящая Политика является неотъемлемой частью Публичной оферты
        сервиса Mailora. В случае противоречий между Политикой и иными документами
        преимущественную силу в части обработки персональных данных имеют
        положения настоящей Политики.
      </p>

      <h2>2. Основные понятия</h2>
      <p>В настоящей Политике используются следующие понятия в значениях, определённых Законом о персональных данных:</p>
      <p>
        2.1. <strong>Персональные данные</strong> — любая информация, относящаяся
        прямо или косвенно к определённому или определяемому физическому лицу
        (субъекту персональных данных).
      </p>
      <p>
        2.2. <strong>Обработка персональных данных</strong> — любое действие
        (операция) или совокупность действий, совершаемых с персональными данными,
        включая сбор, запись, систематизацию, накопление, хранение, уточнение
        (обновление, изменение), извлечение, использование, передачу
        (предоставление, доступ), обезличивание, блокирование, удаление,
        уничтожение.
      </p>
      <p>
        2.3. <strong>Оператор</strong> — Индивидуальный предприниматель Сидоренко Руслан Владимирович,
        самостоятельно организующий и осуществляющий обработку персональных
        данных, а также определяющий цели и содержание обработки.
      </p>
      <p>
        2.4. <strong>Субъект персональных данных (Пользователь, Лицензиат)</strong> —
        физическое лицо, индивидуальный предприниматель либо представитель
        юридического лица, использующее Сервис, к которому относятся персональные
        данные.
      </p>
      <p>
        2.5. <strong>Сервис Mailora</strong> — программно-аппаратный комплекс,
        доступный по адресу www.mailora.ru, предназначенный для автоматизации email-аутрича
        и деловой переписки, включая подключение собственных почтовых ящиков,
        загрузку баз получателей, создание цепочек и авторассылок, настройку
        персонализации, встроенный инбокс, Telegram-уведомления и связанные
        функции.
      </p>
      <p>
        2.6. <strong>Инбокс</strong> — функциональная возможность Сервиса для
        чтения и отправки электронных писем по подключённым почтовым ящикам
        Пользователя внутри интерфейса Сервиса.
      </p>
      <p>
        2.7. <strong>Telegram-уведомления</strong> — сервисные сообщения,
        направляемые Пользователю через подключённый им Telegram-аккаунт.
      </p>
      <p>
        2.8. Иные термины толкуются в соответствии с Законом о персональных данных,
        Публичной офертой и действующим законодательством Российской Федерации.
      </p>

      <h2>3. Правовые основания обработки персональных данных</h2>
      <p>3.1. Обработка персональных данных осуществляется на следующих правовых основаниях:</p>
      <ul>
        <li>согласие субъекта персональных данных (пункт 1 части 1 статьи 6 Закона о персональных данных), выражаемое отдельным действием (отдельным документом или отдельной формой) при регистрации и использовании Сервиса в соответствии с требованиями части 1 статьи 9 Закона о персональных данных;</li>
        <li>необходимость исполнения договора (Публичной оферты), стороной которого является субъект персональных данных (пункт 5 части 1 статьи 6 Закона о персональных данных);</li>
        <li>необходимость исполнения обязанностей, возложенных на Оператора законодательством Российской Федерации (пункт 2 части 1 статьи 6 Закона о персональных данных);</li>
        <li>осуществление прав и законных интересов Оператора при условии, что при этом не нарушаются права и свободы субъекта персональных данных (пункт 7 части 1 статьи 6 Закона о персональных данных), в части обеспечения безопасности и работоспособности Сервиса.</li>
      </ul>
      <p>
        3.2. Обработка контактных сведений, загружаемых Пользователем в Базы
        получателей, осуществляется Оператором по поручению Пользователя.
        Оператором таких сведений является Пользователь; он самостоятельно
        обеспечивает наличие правовых оснований, предусмотренных статьёй 6 Закона о
        персональных данных.
      </p>

      <h2>4. Перечень обрабатываемых персональных данных</h2>
      <p>4.1. Оператор обрабатывает следующие категории персональных данных Пользователей Сервиса:</p>
      <p><strong>При регистрации и авторизации:</strong></p>
      <ul>
        <li>адрес электронной почты;</li>
        <li>имя (при указании);</li>
        <li>идентификатор Telegram (при указании по желанию Пользователя);</li>
        <li>номер телефона (при указании по желанию Пользователя);</li>
      </ul>
      <p><strong>Технические данные:</strong></p>
      <ul>
        <li>IP-адрес;</li>
        <li>данные о браузере и устройстве;</li>
        <li>дата и время обращения, данные сессии;</li>
        <li>файлы cookie и аналогичные технологии;</li>
        <li>логи действий в Сервисе, история использования функционала.</li>
      </ul>
      <p><strong>Данные, связанные с использованием Сервиса:</strong></p>
      <ul>
        <li>сведения о выбранном тарифе и истории платежей;</li>
        <li>загруженные Пользователем файлы (в том числе CSV с контактными данными);</li>
        <li>данные о подключённых почтовых ящиках и настройках рассылок в объёме, необходимом для предоставления функционала;</li>
        <li>содержание переписки, отображаемой во встроенном Инбоксе, в объёме, необходимом для предоставления функционала;</li>
        <li>идентификатор Telegram-аккаунта, подключённого для получения уведомлений.</li>
      </ul>
      <p>
        4.2. Оператор не обрабатывает специальные категории персональных данных
        (сведения о расовой, национальной принадлежности, политических взглядах,
        религиозных или философских убеждениях, состоянии здоровья, интимной жизни)
        и биометрические персональные данные. Пользователю запрещается передавать
        такие данные через Сервис.
      </p>
      <p>
        4.3. Сервис не предназначен для использования лицами младше 18
        (восемнадцати) лет. Оператор не осуществляет целенаправленный сбор
        персональных данных несовершеннолетних.
      </p>
      <p>
        4.4. Оператор не получает и не хранит полные реквизиты банковских карт. Все
        платёжные данные вводятся и обрабатываются непосредственно на стороне
        платёжных сервисов.
      </p>
      <p>
        4.5. В отношении контактных сведений, загружаемых Пользователем в Базы
        получателей, Оператор осуществляет их техническую обработку (хранение,
        предоставление доступа Пользователю) исключительно в целях предоставления
        функционала Сервиса. Оператором персональных данных в части определения
        целей и способов дальнейшего использования таких сведений (направление
        сообщений, формирование собственных баз и т.п.) является Пользователь.
        Пользователь самостоятельно обеспечивает наличие правовых оснований для
        обработки указанных сведений.
      </p>
      <p>
        4.6. Любое лицо вправе потребовать исключения своих контактных сведений из
        обработки, направив обращение на privacy@mailora.ru. Такие сведения
        включаются в реестр исключений и блокируются к отправке через Сервис.
      </p>

      <h2>5. Цели обработки персональных данных</h2>
      <p>5.1. Обработка персональных данных осуществляется исключительно в следующих целях:</p>
      <ul>
        <li>идентификация и аутентификация Пользователя, предоставление доступа к Сервису;</li>
        <li>предоставление функционала: подключение почтовых ящиков, загрузка баз получателей, создание цепочек и авторассылок, настройка персонализации, встроенный инбокс, Telegram-уведомления, аналитика;</li>
        <li>оформление, сопровождение и автопродление тарифов, приём платежей;</li>
        <li>направление сервисных уведомлений (о статусе тарифа, изменениях в Сервисе, ответах на обращения, событиях рассылок);</li>
        <li>направление маркетинговых сообщений о Сервисе (при наличии отдельного согласия);</li>
        <li>обеспечение работоспособности, безопасности Сервиса и защита от мошенничества и злоупотреблений;</li>
        <li>улучшение Сервиса и анализ статистики использования;</li>
        <li>исполнение требований законодательства Российской Федерации.</li>
      </ul>

      <h2>6. Принципы и условия обработки персональных данных</h2>
      <p>6.1. Обработка персональных данных осуществляется на основе принципов, установленных частью 1 статьи 5 Закона о персональных данных:</p>
      <ul>
        <li>законности и справедливости;</li>
        <li>ограничения обработки достижением конкретных, заранее определённых и законных целей;</li>
        <li>недопустимости объединения баз данных, содержащих персональные данные, обработка которых осуществляется в несовместимых целях;</li>
        <li>соответствия содержания и объёма обрабатываемых данных заявленным целям (минимизация данных);</li>
        <li>обеспечения точности, достаточности и актуальности персональных данных;</li>
        <li>хранения данных не дольше, чем этого требуют цели обработки, если иной срок не установлен федеральным законом;</li>
        <li>обеспечения конфиденциальности и безопасности персональных данных.</li>
      </ul>
      <p>
        6.2. Обработка допускается только при наличии хотя бы одного из правовых
        оснований, предусмотренных статьёй 6 Закона о персональных данных.
      </p>
      <p>
        6.3. Оператор не принимает решений, порождающих юридические последствия в
        отношении субъекта персональных данных или иным образом затрагивающих его
        права и законные интересы, на основании исключительно автоматизированной
        обработки персональных данных.
      </p>

      <h2>7. Порядок и условия обработки персональных данных</h2>
      <p>
        7.1. Обработка персональных данных осуществляется как с использованием
        средств автоматизации, так и без использования таких средств.
      </p>
      <p>7.2. Сбор персональных данных осуществляется:</p>
      <ul>
        <li>при регистрации и входе в Сервис (адрес электронной почты, данные сквозной авторизации, при указании — Telegram и телефон);</li>
        <li>при подключении почтовых ящиков и настройке рассылок;</li>
        <li>при загрузке баз получателей;</li>
        <li>при использовании встроенного Инбокса;</li>
        <li>при оформлении тарифа и взаимодействии с платёжными сервисами;</li>
        <li>автоматически при использовании Сервиса (технические данные, логи);</li>
        <li>при обращении Пользователя в поддержку.</li>
      </ul>
      <p>
        7.3. Хранение персональных данных осуществляется на электронных носителях с
        использованием баз данных, расположенных на территории Российской
        Федерации.
      </p>
      <p>
        7.4. Использование персональных данных допускается исключительно в целях,
        указанных в разделе 5 настоящей Политики, и в объёме, необходимом для
        достижения этих целей.
      </p>
      <p>
        7.5. Передача персональных данных третьим лицам осуществляется только при
        наличии правовых оснований и в объёме, необходимом для достижения целей
        обработки.
      </p>
      <p>
        7.6. Блокирование персональных данных производится Оператором в случае
        выявления неправомерной обработки либо по требованию субъекта персональных
        данных или уполномоченного органа.
      </p>
      <p>
        7.7. Уничтожение или обезличивание персональных данных производится по
        достижении целей обработки, при отзыве согласия (если обработка
        осуществляется только на основании согласия), по требованию субъекта или
        уполномоченного органа, а также по истечении сроков хранения, установленных
        настоящей Политикой и законодательством. Удаление учётной записи
        осуществляется по письменному запросу Пользователя, направленному на адрес
        privacy@mailora.ru, в срок, не превышающий 10 (десяти) рабочих дней.
      </p>
      <p>
        7.8. Ответственным за организацию обработки персональных данных является
        Оператор.
      </p>
      <p>
        7.9. Доступ к персональным данным имеют сотрудники Оператора, которым такой
        доступ необходим для выполнения служебных обязанностей (включая оказание
        технической поддержки и расследование нарушений), и которые ознакомлены с
        требованиями Закона о персональных данных и настоящей Политики. Оператор
        вправе осуществлять доступ к учётным записям Пользователей в указанных
        целях.
      </p>

      <h2>8. Передача персональных данных третьим лицам</h2>
      <p>
        8.1. Оператор не продаёт персональные данные и не передаёт их третьим лицам,
        за исключением случаев, предусмотренных настоящей Политикой и
        законодательством Российской Федерации.
      </p>
      <p>8.2. Оператор передаёт персональные данные следующим лицам в объёме, необходимом для функционирования Сервиса:</p>
      <ul>
        <li>платёжным системам Robokasssa — для приёма и обработки платежей и рекуррентных списаний;</li>
        <li>системам аналитики Yandex Metrica — для сбора и анализа статистики использования Сервиса;</li>
        <li>сервисам доставки уведомлений (включая Telegram) — для направления сервисных сообщений;</li>
        <li>хостинг-провайдерам — для размещения инфраструктуры Сервиса.</li>
      </ul>
      <p>
        8.3. Оператор вправе передавать персональные данные государственным органам
        по основаниям и в порядке, установленным законодательством Российской
        Федерации.
      </p>

      <h2>9. Трансграничная передача персональных данных</h2>
      <p>
        9.1. Основные базы данных Сервиса размещены на территории Российской
        Федерации.
      </p>
      <p>
        9.2. Использование отдельных функций Сервиса (в том числе сервисов доставки
        уведомлений) может предполагать передачу ограниченного объёма технических
        данных лицам, находящимся за пределами Российской Федерации. Такая передача
        осуществляется исключительно в целях исполнения конкретного запроса
        Пользователя и при наличии законных оснований. В случае изменения практики
        трансграничной передачи Оператор внесёт соответствующие изменения в
        настоящую Политику с предварительным уведомлением Пользователей.
      </p>

      <h2>10. Меры по защите персональных данных</h2>
      <p>
        10.1. Оператор принимает необходимые правовые, организационные и
        технические меры для защиты персональных данных от неправомерного или
        случайного доступа, уничтожения, изменения, блокирования, копирования,
        предоставления, распространения, а также от иных неправомерных действий.
      </p>
      <p>10.2. К организационным мерам относятся:</p>
      <ul>
        <li>назначение ответственного за организацию обработки персональных данных;</li>
        <li>ограничение круга лиц, имеющих доступ к персональным данным;</li>
        <li>ознакомление лиц, имеющих доступ к данным, с требованиями законодательства и настоящей Политики;</li>
        <li>осуществление внутреннего контроля процессов обработки.</li>
      </ul>
      <p>10.3. К техническим мерам относятся:</p>
      <ul>
        <li>использование защищённого соединения HTTPS/TLS при передаче данных;</li>
        <li>хранение данных на серверах, расположенных на территории Российской Федерации;</li>
        <li>разграничение прав доступа;</li>
        <li>исключение хранения полных платёжных реквизитов;</li>
        <li>резервное копирование баз данных;</li>
        <li>ведение логов действий;</li>
        <li>регулярная оценка эффективности применяемых мер защиты.</li>
      </ul>
      <p>
        10.4. В случае выявления инцидента, связанного с нарушением безопасности
        персональных данных, Оператор проводит внутреннее расследование, принимает
        меры по устранению последствий и при необходимости уведомляет
        уполномоченный орган и субъектов персональных данных в порядке,
        установленном законодательством.
      </p>

      <h2>11. Сроки хранения персональных данных</h2>
      <p>
        11.1. Персональные данные хранятся не дольше, чем этого требуют цели
        обработки, если иной срок не установлен федеральным законом.
      </p>
      <p>11.2. Оператор устанавливает следующие сроки хранения:</p>
      <ul>
        <li>данные учётной записи Пользователя — в течение всего периода использования Сервиса и после его прекращения до момента удаления учётной записи по письменному запросу субъекта персональных данных;</li>
        <li>данные, связанные с оплатой, — в течение сроков, установленных налоговым и бухгалтерским законодательством Российской Федерации;</li>
        <li>технические логи — от 7 (семи) дней и более в зависимости от конкретного микросервиса;</li>
        <li>резервные копии — в соответствии с политикой резервного копирования инфраструктуры.</li>
      </ul>
      <p>
        11.3. По истечении установленных сроков персональные данные подлежат
        уничтожению или обезличиванию в порядке, установленном Законом о
        персональных данных, за исключением данных, обязательное хранение которых
        предусмотрено законодательством.
      </p>

      <h2>12. Права субъектов персональных данных</h2>
      <p>12.1. Субъект персональных данных имеет право:</p>
      <ul>
        <li>получать информацию, касающуюся обработки его персональных данных;</li>
        <li>требовать уточнения, блокирования или уничтожения персональных данных, если они являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленных целей обработки;</li>
        <li>отозвать согласие на обработку персональных данных;</li>
        <li>требовать прекращения обработки и удаления учётной записи;</li>
        <li>обжаловать действия или бездействие Оператора в Роскомнадзор или в судебном порядке.</li>
      </ul>
      <p>
        12.2. Для реализации прав субъект персональных данных направляет запрос на
        адрес электронной почты privacy@mailora.ru. Запрос должен содержать
        сведения, позволяющие идентифицировать субъекта (адрес электронной почты,
        указанный при регистрации, и иные данные), и существо требования.
      </p>
      <p>
        12.3. Оператор рассматривает запрос и предоставляет ответ в срок, не
        превышающий 10 (десяти) рабочих дней с даты получения запроса. При
        необходимости срок может быть продлён не более чем на 5 (пять) рабочих дней
        с уведомлением субъекта персональных данных о причинах продления.
      </p>
      <p>
        12.4. Удаление учётной записи осуществляется по письменному запросу
        Пользователя, направленному на адрес электронной почты privacy@mailora.ru.
        После удаления данные уничтожаются или обезличиваются в срок, не
        превышающий 10 (десяти) рабочих дней, за исключением данных, подлежащих
        обязательному хранению по закону.
      </p>

      <h2>13. Порядок отзыва согласия</h2>
      <p>
        13.1. Субъект персональных данных вправе в любое время отозвать согласие на
        обработку персональных данных путём направления уведомления на адрес
        contact@mailora.ru.
      </p>
      <p>
        13.2. Оператор прекращает обработку персональных данных, осуществляемую на
        основании согласия, в срок, не превышающий 10 (десяти) рабочих дней с даты
        получения отзыва. Указанный срок может быть продлён не более чем на пять
        рабочих дней при направлении мотивированного уведомления.
      </p>
      <p>
        13.3. Отзыв согласия может повлечь невозможность дальнейшего использования
        Сервиса, поскольку обработка персональных данных является необходимым
        условием предоставления доступа к функциям Сервиса.
      </p>
      <p>
        13.4. Отзыв согласия не влияет на законность обработки, осуществлявшейся до
        момента получения отзыва.
      </p>

      <h2>14. Использование файлов cookie и сервисов аналитики</h2>
      <p>
        14.1. На сайте Сервиса используются файлы cookie и аналогичные технологии
        для обеспечения работоспособности Сервиса, сохранения настроек пользователя
        и сбора статистики.
      </p>
      <p>
        14.2. Технически необходимые cookie применяются для функционирования
        Сервиса и не требуют отдельного согласия.
      </p>
      <p>
        14.3. Оператор использует сервисы веб-аналитики Yandex Metrica. При первом
        заходе на сайт отображается баннер об использовании cookie. Внутри Сервиса
        применяются иные cookie, необходимые для корректной работы интерфейса.
      </p>
      <p>
        14.4. Пользователь может ограничить или запретить использование cookie
        средствами настроек своего браузера. Отключение отдельных категорий cookie
        может повлиять на работоспособность отдельных функций Сервиса.
      </p>
      <p>
        14.5. Подробная информация об использовании cookie содержится в Политике
        обработки файлов cookie, размещённой на сайте Сервиса.
      </p>

      <h2>15. Ответственность</h2>
      <p>
        15.1. Лица, виновные в нарушении требований законодательства Российской
        Федерации в сфере персональных данных и положений настоящей Политики, несут
        ответственность в соответствии с действующим законодательством Российской
        Федерации.
      </p>

      <h2>16. Контактная информация Оператора</h2>
      <p>
        16.1. По всем вопросам, связанным с обработкой персональных данных,
        реализацией прав субъекта, отзывом согласия и иными обращениями, субъект
        персональных данных может направить запрос:
      </p>
      <ul>
        <li>по вопросам субъектов персональных данных и исключения из обработки: contact@mailora.ru;</li>
        <li>по общим вопросам: contact@mailora.ru.</li>
      </ul>
      <p>16.2. Реквизиты Оператора:</p>
      <p>
        Индивидуальный предприниматель Сидоренкко Руслан Владимирович
        <br />
        ОГРНИП: 317619600088799
        <br />
        ИНН: 611300126009
        <br />
        Адрес: Ростов-на-Дону, пр-кт Ленина 243/1
        <br />
        Адрес электронной почты: contact@mailora.ru
        <br />
        Сайт: wwww.mailora.ru
      </p>
      <p>
        Актуальная версия настоящей Политики постоянно доступна по адресу https://mailora.ru/privacy.
      </p>
      <p>Дата публикации настоящей редакции: 16.09.2026</p>

      <h2>Контакты</h2>
      <p>
        По вопросам обработки персональных данных:{' '}
        <a href="mailto:contact@mailora.ru">contact@mailora.ru</a>
      </p>
    </LegalLayout>
  );
}